export default{
    namespaced: true,

    state:{
        estados:[
            {value:1, text:"Registrado", color:"purple"},
            {value:2, text:"Recolectado", color:"blue"},
            {value:3, text:"En proceso", color:"orange"},
            {value:4, text:"Terminado", color:"green"},
            //{value:99, text:"Cancelado"},
        ],
    },
    mutations:{
//        CAMBIA_FECHA(state, data){
//          state.fecha = data
//        },
    },
    actions:{
        //
    },
    getters:{
        //
    },
}